import { axiosClient } from './AxiosClient'

function countNotification(callback, errorCallback){
    let url = "/notification/count"

    axiosClient.get(url, {
        params: {
            building_id: localStorage.getItem('building_id')
        }
    })
    .then((response)=>{
        let data = response.data
        let bell = data.bell
        let inbox = data.inbox
        callback(bell, inbox)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listNotification(page, size, callback, errorCallback){
    let url = "/notification"

    var query = {
        page: page,
        size: size
    }

    axiosClient.get(url,{
        params: query
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

async function countAdmin(callback, errorCallback){
    let url = "/notification/admin/count"
    try{
        const response = await axiosClient.get(url)
        callback(response.data)
    }catch(e){
        errorCallback(e)
    }
}

export { countNotification, listNotification, countAdmin }